module.exports = __webpack_public_path__ + "img/two1Blue.af91921f.png";